import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "sc-container-section" }
const _hoisted_2 = {
  class: "sc-row",
  role: "header"
}
const _hoisted_3 = { class: "sc-form-buttons" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "sc-row" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "tabs-container scrollbar-container" }
const _hoisted_9 = ["onClick"]

import '@/assets/css/scrollbar.css';
	import { computed, onMounted, ref, nextTick, watch, onBeforeUnmount } from 'vue';
  import functions from "@/use/functions";	
  import PermissionsWrapper from "@/components/wrappers/PermissionsWrapper.vue";
  import { Permissions, PermissionLevels } from "@/models/permissions";
  import { useDisbursementsStore } from '@/store/store/disbursementsStore';
  import { CertificationVM } from "@/types/certifications";
  import {
    DisbursementVM,    
  } from "@/types/disbursements";
	import TableTab from '@/components/v2/disbursements/DisbursementsTable.vue';
	import HistoryTab from '@/components/v2/disbursements/TabDisbursementHistory.vue';
	
  interface TabViewModel {
		name: string;
		identifier: string;
	}
	
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementsSection',
  props: {
    certification: {}
  },
  emits: ["certificationUpdated"],
  setup(__props: any, { emit: __emit }) {

	const props = __props;

  const emit = __emit;

	const tabs = ref<TabViewModel[]>([
    { name: "Disbursements", identifier: "table" },
    { name: "Disbursement History", identifier: "history" },
  ]);

  const activeTab = ref<string>(tabs.value[0].identifier);
  const hasDirty = ref(false);
  const isLoading = ref<boolean>(true);
  const store = useDisbursementsStore();

  onMounted(() => {
    store.$reset();
    store.setDisbursements(props.certification.disbursements || []);    
    isLoading.value = false;
  });

  onBeforeUnmount(() => {    
    store.$reset();
  });

  watch(
    () => props.certification.form.id,
    (newCertId, oldCertId) => {
      if (oldCertId !== undefined && newCertId !== oldCertId) {
        store.$reset();
        store.setDisbursements(props.certification.disbursements || []);        
        activeTab.value = 'table';
        hasDirty.value = false;
        editingPostDisbFromHistory.value = null;
      }
    }
  );
  
  const tabComponents = {
		table: TableTab,
		history: HistoryTab
	};

  const editingPostDisbFromHistory = ref<{
    disbursementId: number;
    postDisbursementChangeAmountLedgerId: number;
  } | null>(null);

  function handleEditPostDisbursementFromHistory(data: {
    disbursementId: number;
    postDisbursementChangeAmountLedgerId: number;
  }) {
    store.setEditRequest(data);
    activeTab.value = 'table';
    editingPostDisbFromHistory.value = data;
  }

  function handleClearEditRequest() {
    store.setEditRequest(null);
    editingPostDisbFromHistory.value = null;
  }

  const tableRef = ref<InstanceType<typeof TableTab> | null>(null); 
  const saving = ref(false);

	const activeTabComponent = computed(() => tabComponents[activeTab.value] || null);

  const activeTabProps = computed(() => {
		switch (activeTab.value) {			
			case 'table':
        return {
          data: props.certification.disbursements,
          certification: props.certification,
          editingPostDisbFromHistory: editingPostDisbFromHistory.value,
          onHasDirtyChanged: (e: { hasDirty: boolean }) => (hasDirty.value = e.hasDirty),          
          onBatchSaveComplete: handleBatchSaveComplete,
          onSaveCancelled: handleSaveCancelled,
          onSaveValidationFailed: handleSaveValidationFailed,
          onSaveFailed: handleSaveFailed,
          onClearEditRequest: handleClearEditRequest,
          isLoading: isLoading.value
        };
      case 'history':
        return {
          certification: props.certification,
          onEditPostDisbursement: handleEditPostDisbursementFromHistory,
        };
			default:        
				return {};
		}
	});
  
  function handleBatchSaveComplete(updatedDisbursements: DisbursementVM[]) {    
    store.setDisbursements(updatedDisbursements);
    const updatedCertification = {
      ...props.certification,
      disbursements: updatedDisbursements
    };
    
    emit('certificationUpdated', updatedCertification);
    
    saving.value = false;       
  }

  function handleSaveCancelled() {
    saving.value = false;
  }

  function handleSaveValidationFailed() {
    saving.value = false;
  }

  function handleSaveFailed() {
    saving.value = false;
  }

  watch(
  () => props.certification.disbursements,
  (newDisbursements) => {    
    if (store.disbursements.length === 0) {
      store.setDisbursements(newDisbursements || []);
      return;
    }    
    if (store.justSaved) {
      store.setDisbursements(newDisbursements || []);
      return;
    }    
    
    if (store.hasDirty || store.editingPostDisbRequest) {
      return;
    }    
    if (newDisbursements.length > 0) {
      store.setDisbursements(newDisbursements || []);
    }
  },
  { deep: true }
);

	function selectTab(tabIdentifier: string) {
    if (tabIdentifier === 'history' && hasDirty.value) {
      functions.openModal({
        title: 'Unsaved Changes',
        description: 'Please save or cancel your changes before switching tabs.',
      });
      return;
    }
		activeTab.value = tabIdentifier;
	}

  async function onSaveAll() {
    if (!tableRef.value?.saveAll) return;
    saving.value = true;
    try {
      await tableRef.value.saveAll();
    } catch (error) {
      saving.value = false;
      functions.openModal({
        title: 'Error',
        description: 'Failed to save changes. Please try again.',
      });
    }    
  }

  function onCancelAll() {
    if (!tableRef.value?.resetAll) return;
    
    functions.openModal({
      title: 'Confirm',
      description: 'Are you sure you want to discard all pending changes?',
      buttons: [
        { title: 'Cancel', onClick: () => functions.closeModal() },
        {
          title: 'Yes, Discard All',
          onClick: () => {
            functions.closeModal();
            nextTick(() => {
              tableRef.value?.resetAll();
            });
          },
        },
      ],
    });
  }
  
  onMounted(async () => {
    if (!tabs.value.some(t => t.identifier === activeTab.value)) {
      activeTab.value = tabs.value[0].identifier;
    }
    await nextTick();
    isLoading.value = false;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sc-container-section-header sc-section-header" }, " Disbursements ", -1)),
      (activeTab.value === 'table' && hasDirty.value)
        ? (_openBlock(), _createBlock(PermissionsWrapper, {
            key: 0,
            disabled: !__props.certification.isEditable,
            showDisabledIfNotVisible: true,
            permissionIds: [_unref(Permissions).CertAndDisburse],
            permissionLevel: _unref(PermissionLevels).Update
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "sc-button cancel",
                  onClick: onCancelAll,
                  disabled: saving.value
                }, "Cancel", 8, _hoisted_4),
                _createElementVNode("button", {
                  class: "sc-button save",
                  onClick: onSaveAll,
                  disabled: saving.value
                }, _toDisplayString(saving.value ? 'Saving...' : 'Save'), 9, _hoisted_5)
              ])
            ]),
            _: 1
          }, 8, ["disabled", "permissionIds", "permissionLevel"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.identifier,
              class: _normalizeClass({ 'tab-button': true, active: activeTab.value === tab.identifier }),
              onClick: ($event: any) => (selectTab(tab.identifier))
            }, _toDisplayString(tab.name), 11, _hoisted_9))
          }), 128))
        ]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(activeTabComponent.value), _mergeProps(activeTabProps.value, {
          class: "tab-content",
          ref_key: "tableRef",
          ref: tableRef
        }), null, 16))
      ])
    ])
  ]))
}
}

})